import {axios as request} from '@/utils/request'

// 查询待办任务列表
export function todoList(query) {
  return request({
    url: '/jeecg-engineering/flowable/task/todoList',
    method: 'get',
    params: query
  })
}

// 完成任务
export function completeTask(data) {
  return request({
    url: '/jeecg-engineering/flowable/task/completeByDateId',
    method: 'post',
    data: data
  })
}

// 委派任务
export function delegate(data) {
  return request({
    url: '/jeecg-engineering/flowable/task/delegate',
    method: 'post',
    data: data
  })
}

// 退回任务
export function returnTask(data) {
  return request({
    url: '/jeecg-engineering/flowable/task/taskReturnByDataId',
    method: 'post',
    data: data
  })
}

// 驳回任务
export function rejectTask(data) {
  return request({
    url: '/jeecg-engineering/flowable/task/taskRejectByDataId',
    method: 'post',
    data: data
  })
}

// 可退回任务列表
export function returnList(data) {
  return request({
    url: '/jeecg-engineering/flowable/task/findReturnTaskListByDataId',
    method: 'post',
    data: data
  })
}

// 下一节点 todo 目前直接自动分配到候选人，不用主动选人，如有需要再开发
export function getNextFlowNode(data) {
  return request({
    url: '/jeecg-engineering/flowable/task/nextFlowNode',
    method: 'post',
    data: data
  })
}

